import { DateTime, Settings } from 'luxon';

export class LuxonUtils {
  static getGreetings(dateTime: DateTime) {
    const { hour } = dateTime;
    if (hour >= 6 && hour < 12) {
      return 'Good Morning';
    } else if (hour >= 12 && hour < 18) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  }

  static toJSDateKeepLocalTime(dateTime?: DateTime | null) {
    return dateTime?.setZone('local', { keepLocalTime: true }).toJSDate();
  }

  static toDateTimeKeepLocalTime(date?: Date | null) {
    if (!date) {
      return undefined;
    }
    return DateTime.fromJSDate(date).setZone('local').setZone(Settings.defaultZone, { keepLocalTime: true });
  }

  static toIsoDay(dateTime?: DateTime) {
    if (!dateTime) {
      return '';
    }
    return dateTime?.toFormat('yyyy-MM-dd');
  }

  static toTimeRangeString(timeRange?: { startTime?: DateTime; endTime?: DateTime }) {
    if (!timeRange) {
      return '';
    }
    if (!timeRange.startTime && !timeRange.endTime) {
      return '';
    }

    if (timeRange.startTime && timeRange.endTime) {
      return `${timeRange.startTime?.toFormat('DD')} ~ ${timeRange.endTime?.toFormat('DD')}`;
    } else if (timeRange.startTime) {
      return `${timeRange.startTime?.toFormat('DD')}`;
    } else if (timeRange.endTime) {
      return `${timeRange.endTime?.toFormat('DD')}`;
    }

    return '';
  }

  static findTimeRange(timeRanges: { startTime?: DateTime; endTime?: DateTime }[]) {
    if (!timeRanges || timeRanges.length === 0) {
      return null;
    }

    const validRanges = timeRanges.filter((range) => range.startTime && range.endTime);

    if (validRanges.length === 0) {
      return null;
    }

    const earliestStartTime = validRanges.reduce(
      (earliest, current) => (current.startTime! < earliest ? current.startTime! : earliest),
      validRanges[0].startTime!
    );

    const latestEndTime = validRanges.reduce(
      (latest, current) => (current.endTime! > latest ? current.endTime! : latest),
      validRanges[0].endTime!
    );

    return { earliestStartTime, latestEndTime };
  }
}
